(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hotspot"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hotspot-block')) {
  class HotspotBlock extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.hotspot-block__button');
      this.openEvent = this.dataset.openEvent || 'click';
      this.isOpen = false;
      this.boundClickOutside = this.handleClickOutside.bind(this);
    }

    connectedCallback() {
      if (this.openEvent === 'click') {
        this.button.addEventListener('click', e => {
          e.stopPropagation();
          this.toggle();
        });
        document.addEventListener('click', this.boundClickOutside);
      } else {
        this.addEventListener('mouseenter', () => this.open());
        this.addEventListener('mouseleave', () => this.close());
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.boundClickOutside);
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    open() {
      this.isOpen = true;
      this.classList.add('is-open');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
    }

    handleClickOutside(e) {
      if (!this.contains(e.target)) this.close();
    }
  }

  customElements.define('hotspot-block', HotspotBlock);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sea-moss-offer-a-picker"] && !Shopify.designMode) return;
  try {
    class SeaMossOfferA extends HTMLElement {
    static giftSyncSource = 'sea-moss-offer-a-gifts';

    connectedCallback() {
      this.abortController = new AbortController();
      this.addEventListener('change', this.handleChange, { signal: this.abortController.signal });
      document.addEventListener('cart:update', this.handleCartUpdate, { signal: this.abortController.signal });
      this.sync();
      this.syncCartGifts();
      customElements.whenDefined('variant-picker').then(() => this.syncSelectedVariant());
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    get selectedOption() {
      return this.querySelector('.sea-moss-offer-a__input:checked')?.closest('.sea-moss-offer-a__option') ?? null;
    }

    get giftVariantIds() {
      return (this.dataset.giftVariantIds || '').split(',').map(Number).filter(Boolean);
    }

    handleChange = (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches('.sea-moss-offer-a__input')) {
        this.sync();
      }
    };

    syncSelectedVariant() {
      if (!this.isConnected) return;

      const checkedInput = this.querySelector('.sea-moss-offer-a__input:checked');
      const productFormId = this.querySelector('variant-picker')?.dataset.productFormId;
      const variantIdInput = productFormId && document.getElementById(productFormId)?.querySelector('input[name="id"]');

      if (checkedInput && variantIdInput && variantIdInput.value !== checkedInput.dataset.variantId) {
        checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    sync() {
      const sellingPlanId = this.selectedOption?.dataset.sellingPlanId || '';
      const sellingPlanInput = this.querySelector('.sea-moss-offer-a__selling-plan');

      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
        sellingPlanInput.disabled = !sellingPlanId;
      }

      window.themeCartCompanion = {
        enabled: Boolean(sellingPlanId) && this.giftVariantIds.length > 0,
        variantIds: sellingPlanId ? this.giftVariantIds : [],
      };
    }

    handleCartUpdate = (event) => {
      if (event.detail?.data?.source !== SeaMossOfferA.giftSyncSource) this.syncCartGifts();
    };

    syncCartGifts() {
      if (this.giftSyncQueued) return;
      this.giftSyncQueued = true;
      this.giftSync = (this.giftSync ?? Promise.resolve())
        .then(() => {
          this.giftSyncQueued = false;
          return this.reconcileCartGifts();
        })
        .catch((error) => console.error(error));
    }

    async reconcileCartGifts() {
      const giftIds = this.giftVariantIds;
      if (giftIds.length === 0) return;

      const cart = await this.requestCart(`${window.Shopify?.routes?.root ?? '/'}cart.js`);
      const productId = Number(this.dataset.productId);
      const offerLines = cart.items.filter((item) => item.product_id === productId);
      const hasSubscription = offerLines.some((item) => item.selling_plan_allocation);
      const hasOtherSubscription = cart.items.some(
        (item) => item.product_id !== productId && item.selling_plan_allocation
      );

      if (offerLines.length === 0 && hasOtherSubscription) return;

      const targetQuantity = hasSubscription ? 1 : 0;
      const updates = {};
      const missingIds = [];
      let itemCount = cart.item_count;

      giftIds.forEach((variantId) => {
        const lines = cart.items.filter((item) => item.variant_id === variantId);
        if (lines.length === 0 && targetQuantity > 0) missingIds.push(variantId);
        lines.forEach((item, index) => {
          const quantity = index === 0 ? targetQuantity : 0;
          if (item.quantity === quantity) return;
          updates[item.key] = quantity;
          itemCount += quantity - item.quantity;
        });
      });

      if (Object.keys(updates).length === 0 && missingIds.length === 0) return;

      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((node) => node.dataset.sectionId)
        .filter(Boolean);
      const sectionsPayload = { sections: [...new Set(sectionIds)].join(','), sections_url: window.location.pathname };
      let result = null;

      if (Object.keys(updates).length > 0) {
        result = await this.requestCart(Theme.routes.cart_update_url, { ...sectionsPayload, updates });
      }

      if (missingIds.length > 0) {
        result = await this.requestCart(Theme.routes.cart_add_url, {
          ...sectionsPayload,
          items: missingIds.map((id) => ({ id, quantity: 1 })),
        });
        itemCount += missingIds.length;
      }

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: SeaMossOfferA.giftSyncSource,
            data: { source: SeaMossOfferA.giftSyncSource, itemCount, sections: result?.sections },
          },
        })
      );
    }

    async requestCart(url, body) {
      const response = await fetch(url, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
      });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      return response.json();
    }
  }

  if (!customElements.get('sea-moss-offer-a')) {
    customElements.define('sea-moss-offer-a', SeaMossOfferA);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sea-moss-offer-b-picker"] && !Shopify.designMode) return;
  try {
    class SeaMossOfferB extends HTMLElement {
    static storageKey = 'sea-moss-offer-b-purchase-mode';
    static giftSyncSource = 'sea-moss-offer-b-gifts';

    connectedCallback() {
      this.abortController = new AbortController();
      this.purchaseSwitch = this.querySelector('.sea-moss-offer-b__switch');
      this.switchButton = this.purchaseSwitch?.querySelector('.sea-moss-offer-b__switch-button');

      this.setPurchaseMode(this.readStoredPurchaseMode() ?? this.dataset.purchaseMode);
      this.addEventListener('change', this.handleChange, { signal: this.abortController.signal });
      document.addEventListener('cart:update', this.handleCartUpdate, { signal: this.abortController.signal });
      this.switchButton?.addEventListener('click', this.togglePurchaseMode, { signal: this.abortController.signal });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.placeSwitchBelowBuyButtons(), {
          once: true,
          signal: this.abortController.signal,
        });
      } else {
        this.placeSwitchBelowBuyButtons();
      }

      this.syncCartGifts();
      customElements.whenDefined('variant-picker').then(() => this.syncSelectedVariant());
    }

    disconnectedCallback() {
      this.abortController?.abort();
      if (this.purchaseSwitch && !this.contains(this.purchaseSwitch)) this.purchaseSwitch.remove();
    }

    placeSwitchBelowBuyButtons() {
      const buyButtons = this.closest('.product-details')?.querySelector('.buy-buttons-block');
      if (buyButtons && this.purchaseSwitch) buyButtons.after(this.purchaseSwitch);
    }

    syncSelectedVariant() {
      if (!this.isConnected) return;

      const checkedInput = this.querySelector('.sea-moss-offer-b__input:checked');

      checkedInput?.dispatchEvent(new Event('change', { bubbles: true }));
    }

    get selectedOption() {
      return this.querySelector('.sea-moss-offer-b__input:checked')?.closest('.sea-moss-offer-b__option') ?? null;
    }

    get giftVariantIds() {
      return (this.dataset.giftVariantIds || '').split(',').map(Number).filter(Boolean);
    }

    handleChange = (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches('.sea-moss-offer-b__input')) {
        this.sync();
      }
    };

    sync() {
      const sellingPlanId =
        this.dataset.purchaseMode === 'subscription' ? this.selectedOption?.dataset.sellingPlanId || '' : '';
      const sellingPlanInput = this.querySelector('.sea-moss-offer-b__selling-plan');

      if (sellingPlanInput) {
        sellingPlanInput.value = sellingPlanId;
        sellingPlanInput.disabled = !sellingPlanId;
      }

      window.themeCartCompanion = {
        enabled: Boolean(sellingPlanId) && this.giftVariantIds.length > 0,
        variantIds: sellingPlanId ? this.giftVariantIds : [],
      };
    }

    handleCartUpdate = (event) => {
      if (event.detail?.data?.source !== SeaMossOfferB.giftSyncSource) this.syncCartGifts();
    };

    syncCartGifts() {
      if (this.giftSyncQueued) return;
      this.giftSyncQueued = true;
      this.giftSync = (this.giftSync ?? Promise.resolve())
        .then(() => {
          this.giftSyncQueued = false;
          return this.reconcileCartGifts();
        })
        .catch((error) => console.error(error));
    }

    async reconcileCartGifts() {
      const giftIds = this.giftVariantIds;
      if (giftIds.length === 0) return;

      const cart = await this.requestCart(`${window.Shopify?.routes?.root ?? '/'}cart.js`);
      const productId = Number(this.dataset.productId);
      const offerLines = cart.items.filter((item) => item.product_id === productId);
      const hasSubscription = offerLines.some((item) => item.selling_plan_allocation);
      const hasOtherSubscription = cart.items.some(
        (item) => item.product_id !== productId && item.selling_plan_allocation
      );

      if (offerLines.length === 0 && hasOtherSubscription) return;

      const targetQuantity = hasSubscription ? 1 : 0;
      const updates = {};
      const missingIds = [];
      let itemCount = cart.item_count;

      giftIds.forEach((variantId) => {
        const lines = cart.items.filter((item) => item.variant_id === variantId);
        if (lines.length === 0 && targetQuantity > 0) missingIds.push(variantId);
        lines.forEach((item, index) => {
          const quantity = index === 0 ? targetQuantity : 0;
          if (item.quantity === quantity) return;
          updates[item.key] = quantity;
          itemCount += quantity - item.quantity;
        });
      });

      if (Object.keys(updates).length === 0 && missingIds.length === 0) return;

      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((node) => node.dataset.sectionId)
        .filter(Boolean);
      const sectionsPayload = { sections: [...new Set(sectionIds)].join(','), sections_url: window.location.pathname };
      let result = null;

      if (Object.keys(updates).length > 0) {
        result = await this.requestCart(Theme.routes.cart_update_url, { ...sectionsPayload, updates });
      }

      if (missingIds.length > 0) {
        result = await this.requestCart(Theme.routes.cart_add_url, {
          ...sectionsPayload,
          items: missingIds.map((id) => ({ id, quantity: 1 })),
        });
        itemCount += missingIds.length;
      }

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: SeaMossOfferB.giftSyncSource,
            data: { source: SeaMossOfferB.giftSyncSource, itemCount, sections: result?.sections },
          },
        })
      );
    }

    async requestCart(url, body) {
      const response = await fetch(url, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
      });
      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      return response.json();
    }

    togglePurchaseMode = () => {
      const mode = this.dataset.purchaseMode === 'one-time' ? 'subscription' : 'one-time';
      this.setPurchaseMode(mode);
      this.storePurchaseMode(mode);
      this.syncSelectedVariant();
    };

    setPurchaseMode(mode) {
      this.dataset.purchaseMode = mode;
      const variantPicker = this.querySelector('variant-picker');
      if (variantPicker) variantPicker.dataset.purchaseMode = mode;
      if (this.purchaseSwitch) this.purchaseSwitch.dataset.purchaseMode = mode;
      this.switchButton?.setAttribute('aria-pressed', String(mode === 'one-time'));
      this.sync();
    }

    readStoredPurchaseMode() {
      try {
        const mode = localStorage.getItem(SeaMossOfferB.storageKey);
        return mode === 'one-time' || mode === 'subscription' ? mode : null;
      } catch {
        return null;
      }
    }

    storePurchaseMode(mode) {
      try {
        localStorage.setItem(SeaMossOfferB.storageKey, mode);
      } catch {}
    }
  }

  if (!customElements.get('sea-moss-offer-b')) {
    customElements.define('sea-moss-offer-b', SeaMossOfferB);
  }
  } catch(e) { console.error(e); }
})();

})();
